import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Growl } from 'primereact/growl';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Moment from 'react-moment';
import { Checkbox } from 'primereact/checkbox';
import servicioPaginacion from '../servicios/ServicioPaginacion';
import servicioDescargaArchivos from '../servicios/ServicioDescargaArchivos';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioUsuario from '../servicios/ServicioUsuario';
import servicioComprobante from '../servicios/ServicioComprobante';



class ConsultasCfdi extends Component {
  constructor() {
    super();
    this.state = {
      mostrarSeleccionados:false,
      cfdiseleccionados: [],
      twCruces:{},
      errorRfc: {},
      errorNru:{},
      trFacturacion: {},
      twReceptor: {},
      twCfdi: {},
      mostrarBotonExcel: false,
      listaCorreos: [],
      objetoPerfil: {},
      cfdi: {},
      erroresFecha: {},
      errorFolio: {},
      errorSerie: {},
      paginacion: {
        registrosPorPagina: 20,
        clase: 'com.mx.quadrum.banobras.facturacion.web.guadalara.colima.backend.entidad.fbanobrasgc.TrFacturacion',
        join: ["twCfdi"],
        conjunciones: {},
        betweenPropertyName: null,
        between: [],
        session: true
      },
      first: 0,
      idUsuario: null,
      mostrarOpcionEstado: { display: 'none' },
      activeIndex:null
    }
    this.descargarDetalleExcel = this.descargarDetalleExcel.bind(this);
    this.descargarDetalleExcelPorRfc = this.descargarDetalleExcelPorRfc.bind(this);
    this.descargarDetalleExcelPorRfcMes = this.descargarDetalleExcelPorRfcMes.bind(this);
    this.descargarDetalleExcelPorRfcAnio = this.descargarDetalleExcelPorRfcAnio.bind(this);
    this.descargarDetalleIngresoEgreso = this.descargarDetalleIngresoEgreso.bind(this);
    this.descargarDetalleIngresoEgresoMes = this.descargarDetalleIngresoEgresoMes.bind(this);
    this.descargarDetalleIngresoEgresoAnio = this.descargarDetalleIngresoEgresoAnio.bind(this);
  }

  componentDidMount() {
    this.obtenerSession();
    this.obtenerNombreUsuario();

  }

  obtenerSession = () => {
    servicioUsuario.usuarioSession().then(response => {
      this.setState({ idUsuario: response.data });
    }).catch(error => {

    });
  }

  obtenerNombreUsuario = () => {
    
    servicioUsuario.nombreDePerfil().then(response => {
      this.setState({ objetoPerfil: response.data });
      if (response.data.nombre.includes("ADMINISTRADOR")) {
        this.setState({ mostrarOpcionEstado: { display: 'block' } });
      }


    }).catch(error => {

    });

  }

  obtenerResultados = () => {
    const { paginacion } = this.state;
    servicioPaginacion.paginacionGeneral(paginacion).then((response) => {
      this.setState({ paginacion: response.data });
    });
  }

  onPage = (event) => {
    this.setState({
      first: event.first
    });
    const { paginacion } = this.state;
    paginacion.numeroPagina = event.page;
    paginacion.registrosPorPagina = event.rows;
    servicioPaginacion.paginacionGeneral(paginacion).then((response) => {
      this.setState({ paginacion: response.data });
    });
  }


  templateDescargaArchivos = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi pi-download" className="p-button-success" onClick={(e) => this.descargaArchivos(rowData)}></Button>
    </div>;
  }

  descargaArchivos = (rowData) => {
    servicioDescargaArchivos.descargaArchivo('documentos/cfdi/descargazip.json', { id: rowData.twCfdi.id });
  }

  validarFormularioFechas = (cfdi) => {
    const errores = {};
    if (!cfdi.fechaCreacion)
      errores.fechaCreacion = "La fecha inicial es requerida";
    if (!cfdi.fechaCertificacion)
      errores.fechaCertificacion = "La fecha final es requerida";
    return errores;
  }

  validarFormularioFolio = (cfdi) => {
    const errores = {};
    if (!cfdi.folio)
      errores.folio = "EL folio es requerido";
    return errores;
  }

  validarFormularioSerie = (cfdi) => {
    const errores = {};
    if (!cfdi.serie)
      errores.serie = "La serie es requerido";
    if (!cfdi.fechaCreacion)
      errores.fechaCreacion = "La fecha inicial es requerida";
    if (!cfdi.fechaCertificacion)
      errores.fechaCertificacion = "La fecha final es requerida";

    return errores;
  }

  validarFormularioRfc = (objeto) => {
    const errorRfc = {};
    if (!objeto.rfc)
      errorRfc.rfc = "El rfc es requerido";
    return errorRfc;
  }

  validarFormularioNru = (objeto) => {
    const errorNru={};
    if (!objeto.nru)
    errorNru.nru="El nru es requerido";
    return errorNru;
  }

  buscarPorFechas = () => {

    let { paginacion, cfdi, objetoPerfil } = this.state;
    const validacion = this.validarFormularioFechas(cfdi)
    var nombreAdministrador = "ADMINISTRADOR";    
    this.setState({ erroresFecha: validacion });
    if (!Object.keys(validacion).length) {
      paginacion.betweenPropertyName = "alias_twCfdi.fechaCreacion";
      paginacion.between = [cfdi.fechaCreacion.getTime(), cfdi.fechaCertificacion.getTime()];

      paginacion.conjunciones = {};
      if (!objetoPerfil.nombre.includes(nombreAdministrador)) {
        let nombrePropiedad = "alias_twCfdi.tipoDeComprobante";
        paginacion.conjunciones[nombrePropiedad] = "I";
      }
      this.setState({ paginacion: paginacion });
      this.obtenerResultados();
    }
  }

  buscarFolio = () => {
    let { paginacion, cfdi, objetoPerfil } = this.state;
    const validacion = this.validarFormularioFolio(cfdi);
    this.setState({ errorFolio: validacion });
    if (!Object.keys(validacion).length) {
      let nombrePropiedad = "alias_twCfdi.folio";
      paginacion.conjunciones = {};
      paginacion.conjunciones[nombrePropiedad] = cfdi.folio;
      var nombreAdministrador = "ADMINISTRADOR";
      if (!objetoPerfil.nombre.includes(nombreAdministrador)) {
        let nombrePropiedad2 = "alias_twCfdi.tipoDeComprobante";
        paginacion.conjunciones[nombrePropiedad2] = "I";
      }
      this.setState({ paginacion: paginacion });
      this.obtenerResultados();
    }
  }

  buscarSerie = () => {
    let { paginacion, cfdi, objetoPerfil } = this.state;
    const validacion = this.validarFormularioSerie(cfdi);
    this.setState({ errorSerie: validacion });
    if (!Object.keys(validacion).length) {
      let nombrePropiedad = "alias_twCfdi.serie";
      paginacion.conjunciones = {};
      paginacion.conjunciones[nombrePropiedad] = cfdi.serie;
      paginacion.betweenPropertyName = "alias_twCfdi.fechaCreacion";
      paginacion.between = [cfdi.fechaCreacion.getTime(), cfdi.fechaCertificacion.getTime()];
      var nombreAdministrador = "ADMINISTRADOR";
      if (!objetoPerfil.nombre.includes(nombreAdministrador)) {
        let nombrePropiedad2 = "alias_twCfdi.tipoDeComprobante";
        paginacion.conjunciones[nombrePropiedad2] = "I";
      }
      this.setState({ paginacion: paginacion });
      this.obtenerResultados();
    }
  }

  buscarFacturaActivo = () => {
    let { paginacion } = this.state;
    let nombrePropiedad = "alias_twCfdi.estado";
    paginacion.conjunciones = {};
    paginacion.conjunciones[nombrePropiedad] = 1;

    this.setState({ paginacion: paginacion });
    this.obtenerResultados();
  }
  buscarFacturaNru = () => {
    
    let { paginacion,twCruces} = this.state;
    const validacion = this.validarFormularioNru(twCruces);
    this.setState({ errorNru: validacion });
    if (!Object.keys(validacion).length) {
    paginacion.conjunciones = {};
    paginacion.conjunciones["alias_twCfdi.alias_twCfdi.twCruceses.nru"] = twCruces.nru;
   servicioComprobante.consultarFacturaNru(paginacion).then(response=>{
    this.setState({ paginacion: response.data });
   });
  }
  }

  buscarFacturaCancelada = () => {
    let { paginacion } = this.state;
    let nombrePropiedad = "alias_twCfdi.estado";
    paginacion.conjunciones = {};
    paginacion.conjunciones[nombrePropiedad] = 6;

    this.setState({ paginacion: paginacion });
    this.obtenerResultados();
  }

  asignarValoresObjeto = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
  }

  reinicioVariables = () => {
    const { objetoPerfil } = this.state;
    this.setState({ mostrarSeleccionados: false, cfdiseleccionados:[],twCruces:{} });
    // console.log(mostrarBotonExcel);
    // console.log(objetoPerfil);
    var nombreAdministrador = "ADMINISTRADOR";
    // console.log(objetoPerfil.nombre.includes(nombreAdministrador));
    var nombrePerfil = true;
    if (objetoPerfil.nombre.includes(nombreAdministrador)) {
      nombrePerfil = false;


      this.setState({ mostrarBotonExcel: true });
    }

    this.setState({
      cfdi: {},
      erroresFecha: {},
      paginacion: {
        registrosPorPagina: 20,
        clase: 'com.mx.quadrum.banobras.facturacion.web.guadalara.colima.backend.entidad.fbanobrasgc.TrFacturacion',
        join: ["twCfdi"],
        conjunciones: {},
        betweenPropertyName: null,
        between: [],
        session: nombrePerfil
      },
      first: 0
    });


  }

  formatofechaCreacion = (rowData, column) => {
    return <Moment format="YYYY-MM-DD HH:mm:ss">
      {rowData.twCfdi.fechaCreacion}
    </Moment>;
  }

  formatofechaCertificacion = (rowData, column) => {

    if (!rowData.twCfdi.fechaCertificacion) {
      return "";
    } else {
      return <Moment format="YYYY-MM-DD HH:mm:ss">
        {rowData.twCfdi.fechaCertificacion}
      </Moment>;
    }
  }

  formatofechaCancelacion = (rowData, column) => {
    if (!rowData.twCfdi.fechaCancelacion) {
      return "";
    } else {
      return <Moment format="YYYY-MM-DD HH:mm:ss">
        {rowData.twCfdi.fechaCancelacion}
      </Moment>;
    }
  }

  formatoEstatus = (rowData, column) => {
    if (rowData.twCfdi.estado === 6)
      return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Cancelado</p>;
    else
      return <p style={{ backgroundColor: '#33ff4c', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Activo</p>
  }


  descargarDetalleExcel() {
    const { cfdi } = this.state;
    if (cfdi.fechaCreacion != null && cfdi.fechaCertificacion != null) {
      cfdi.fechaCreacion = cfdi.fechaCreacion.getTime();
      cfdi.fechaCertificacion = cfdi.fechaCertificacion.getTime();
    }
    servicioDescargaArchivos.descargaArchivo('/documentos/descargaDetalleFacturacion.json', cfdi);
    this.setState({ cfdi: {} });
  }

  descargarDetalleExcelPorRfc() {
    const { twReceptor, trFacturacion } = this.state;
    const validacion = this.validarFormularioRfc(twReceptor);
    this.setState({ errorRfc: validacion });
    if (!Object.keys(validacion).length) {
      trFacturacion.twReceptor = twReceptor;
      servicioDescargaArchivos.descargaArchivo('/documentos/descargaDetalleFacturacionPorRfc.json', trFacturacion);
    }
  }

  descargarDetalleExcelPorRfcMes() {
    const { twReceptor, trFacturacion } = this.state;
    const validacion = this.validarFormularioRfc(twReceptor);
    this.setState({ errorRfc: validacion });
    if (!Object.keys(validacion).length) {
      trFacturacion.twReceptor = twReceptor;
      servicioDescargaArchivos.descargaArchivo('/documentos/descargaDetalleFacturacionPorRfcMes.json', trFacturacion);
    }
  }

  descargarDetalleExcelPorRfcAnio() {
    const { twReceptor, trFacturacion } = this.state;
    const validacion = this.validarFormularioRfc(twReceptor);
    this.setState({ errorRfc: validacion });
    if (!Object.keys(validacion).length) {
      trFacturacion.twReceptor = twReceptor;
      servicioDescargaArchivos.descargaArchivo('/documentos/descargaDetalleFacturacionPorRfcAnio.json', trFacturacion);
    }
  }

  descargarDetalleIngresoEgreso() {
    const { trFacturacion, twCfdi } = this.state;
    twCfdi.id = 1;
    trFacturacion.twCfdi = twCfdi;
    servicioDescargaArchivos.descargaArchivo('/documentos/descargaDetalleFacturacionIngresoEgreso.json', trFacturacion);
    this.setState({ trFacturacion: {} });
    this.setState({ twCfdi: {} });
  }

  descargarDetalleIngresoEgresoMes() {
    const { trFacturacion, twCfdi } = this.state;
    twCfdi.id = 2;
    trFacturacion.twCfdi = twCfdi;
    servicioDescargaArchivos.descargaArchivo('/documentos/descargaDetalleFacturacionIngresoEgreso.json', trFacturacion);
    this.setState({ trFacturacion: {} });
    this.setState({ twCfdi: {} });
  }
  descargarDetalleIngresoEgresoAnio() {
    const { trFacturacion, twCfdi } = this.state;
    twCfdi.id = 3;
    trFacturacion.twCfdi = twCfdi;
    servicioDescargaArchivos.descargaArchivo('/documentos/descargaDetalleFacturacionIngresoEgreso.json', trFacturacion);
    this.setState({ trFacturacion: {} });
    this.setState({ twCfdi: {} });
  }
  actionTemplate = (rowData, column) => {
   
      return <div>
        <Checkbox inputId="cb1" value={rowData.twCfdi.id} onChange={this.validarRegistrosObjetos} checked={this.state.cfdiseleccionados.indexOf(rowData.twCfdi.id) !== -1} ></Checkbox>
      </div>;



  }

  validarRegistrosObjetos = (e) => {
    let selectedcfdi = [...this.state.cfdiseleccionados];

    if (e.checked)
      selectedcfdi.push(e.value);
    else
      selectedcfdi.splice(selectedcfdi.indexOf(e.value), 1);

    if (selectedcfdi.length > 0) {
      this.setState({ cfdiseleccionados: selectedcfdi,mostrarSeleccionados:true });
    } else {
      this.setState({ cfdiseleccionados: selectedcfdi, mostrarSeleccionados:false});
    }
  }

  descargarCfdis = () => {
    const { cfdiseleccionados } = this.state;
    console.log(cfdiseleccionados);
    servicioDescargaArchivos.descargaArchivo('/documentos/cfdi/descargazipMasiva.json', cfdiseleccionados);
 
  }

  descargaMasiva = () => {
    this.asignarRestricciones();
    let { paginacion } = this.state;
    servicioDescargaArchivos.descargaArchivo("/documentos/descarga_masiva_criterios.json", paginacion);
  }

  asignarRestricciones = () => {
    let { paginacion, cfdi, objetoPerfil, twCruces } = this.state;
    paginacion.conjunciones = {};
    if (!servicioAsignacionValoresObjetos.esObjetoVacio(cfdi.fechaCreacion) && !servicioAsignacionValoresObjetos.esObjetoVacio(cfdi.fechaCertificacion)) {
      paginacion.betweenPropertyName = "alias_twCfdi.fechaCertificacion";
      paginacion.between = [cfdi.fechaCreacion.getTime(), cfdi.fechaCertificacion.getTime()];
    }

    if (!servicioAsignacionValoresObjetos.esObjetoVacio(cfdi.folio)) {
      paginacion.conjunciones["alias_twCfdi.folio"] = cfdi.folio;
    }
    if (!servicioAsignacionValoresObjetos.esObjetoVacio(cfdi.serie)) {
      paginacion.conjunciones["alias_twCfdi.serie"] = cfdi.serie;
    }
    if (!servicioAsignacionValoresObjetos.esObjetoVacio(twCruces.nru)) {
      paginacion.conjunciones["alias_twCfdi.alias_twCfdi.twCruceses.nru"] = twCruces.nru;
    }

    var nombreAdministrador = "ADMINISTRADOR";
    if (!objetoPerfil.nombre.includes(nombreAdministrador)) {
      let nombrePropiedad2 = "alias_twCfdi.tipoDeComprobante";
      paginacion.conjunciones[nombrePropiedad2] = "I";
    }
    this.setState({ paginacion: paginacion });
  }



  render() {
    const { erroresFecha, cfdi, paginacion, first, errorFolio, errorSerie, mostrarBotonExcel, twReceptor, errorRfc, mostrarOpcionEstado, twCruces,mostrarSeleccionados,errorNru } = this.state;
    const es = {
      firstDayOfWeek: 1,
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "Mi", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
    };
    return (

      <div>
        <Growl ref={(el) => this.growl = el} />
        <h1>Administración de Consultas</h1>
        <Accordion onTabOpen={this.reinicioVariables} onTabClose={this.reinicioVariables} activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({activeIndex: e.index})}>
          <AccordionTab header="Búsqueda por fecha" >
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-4">
                <h4>*Fecha Inicial:</h4>
                <Calendar id="fechaCreacion" name="cfdi.fechaCreacion" value={cfdi.fechaCreacion || ''} onChange={this.asignarValoresObjeto} className={erroresFecha.fechaCreacion ? 'p-error' : ''} locale={es} dateFormat="yy-mm-dd" showTime={true} showSeconds={true} />
                {erroresFecha.fechaCreacion ? <div><br /> <Message severity="error" text={erroresFecha.fechaCreacion} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">
                <h4>*Fecha Final:</h4>
                <Calendar id="fechaCertificacion" name="cfdi.fechaCertificacion" value={cfdi.fechaCertificacion || ''} onChange={this.asignarValoresObjeto} className={erroresFecha.fechaCertificacion ? 'p-error' : ''} locale={es} dateFormat="yy-mm-dd" showTime={true} showSeconds={true} />
                {erroresFecha.fechaCertificacion ? <div><br /> <Message severity="error" text={erroresFecha.fechaCertificacion} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">
                <br /><br /><br />
                <Button label="Buscar" className="p-button-rounded p-button-warning" onClick={this.buscarPorFechas} />
              </div>
              <div className="p-col-12 p-md-4">
                <br /><br /><br />

                {mostrarBotonExcel ?
                  <Button label="Descarcar Excel" className="p-button-rounded p-button-warning" onClick={this.descargarDetalleExcel} />
                  : null}
              </div>



            </div>
          </AccordionTab>
          <AccordionTab header="Búsqueda por folio">
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-4">
                <h4>*Folio:</h4>
                <InputText id="folio" name="cfdi.folio" value={cfdi.folio || ''} onChange={this.asignarValoresObjeto} className={errorFolio.folio ? 'p-error' : ''} />
                {erroresFecha.folio ? <div><br /> <Message severity="error" text={erroresFecha.folio} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">
                <br /><br /><br />
                <Button label="Buscar" className="p-button-rounded p-button-warning" onClick={this.buscarFolio} />
              </div>
              <div className="p-col-12 p-md-4">
                <br /><br /><br />
                {mostrarBotonExcel ?
                  <Button label="Descarcar Excel" className="p-button-rounded p-button-warning" onClick={this.descargarDetalleExcel} />
                  : null}
              </div>
            </div>
          </AccordionTab>
          <AccordionTab header="Búsqueda por serie">
            <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-4">
                <h4>*Fecha Inicial:</h4>
                <Calendar id="fechaCreacion" name="cfdi.fechaCreacion" value={cfdi.fechaCreacion || ''} onChange={this.asignarValoresObjeto} className={erroresFecha.fechaCreacion ? 'p-error' : ''} locale={es} dateFormat="yy-mm-dd" showTime={true} showSeconds={true} />
                {errorSerie.fechaCreacion ? <div><br /> <Message severity="error" text={errorSerie.fechaCreacion} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">
                <h4>*Fecha Final:</h4>
                <Calendar id="fechaCertificacion" name="cfdi.fechaCertificacion" value={cfdi.fechaCertificacion || ''} onChange={this.asignarValoresObjeto} className={erroresFecha.fechaCertificacion ? 'p-error' : ''} locale={es} dateFormat="yy-mm-dd" showTime={true} showSeconds={true} />
                {errorSerie.fechaCertificacion ? <div><br /> <Message severity="error" text={errorSerie.fechaCertificacion} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">
                <h4>*Serie:</h4>
                <InputText id="serie" name="cfdi.serie" value={cfdi.serie || ''} onChange={this.asignarValoresObjeto} className={errorFolio.folio ? 'p-error' : ''} />
                {errorSerie.serie ? <div><br /> <Message severity="error" text={errorSerie.serie} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">
                <br /><br /><br />
                <Button label="Buscar" className="p-button-rounded p-button-warning" onClick={this.buscarSerie} />
              </div>
              <div className="p-col-12 p-md-4">
                <br /><br /><br />
                {mostrarBotonExcel ?
                  <Button label="Descarcar Excel" className="p-button-rounded p-button-warning" onClick={this.descargarDetalleExcel} />
                  : null}
              </div>
            </div>
          </AccordionTab>
          <AccordionTab header="Búsqueda por NRU">
          <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-4">
          <h4>*NRU:</h4>
                <InputText id="nru" name="twCruces.nru" value={twCruces.nru || ''} onChange={this.asignarValoresObjeto} className={errorNru.nru ? 'p-error' : ''} />
                {errorNru.nru ? <div><br /> <Message severity="error" text={errorNru.nru} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4">
                <br /><br /><br />
                <Button label="Buscar" className="p-button-rounded p-button-warning" onClick={this.buscarFacturaNru}  />
               
              </div>
          </div>
          </AccordionTab>

          <AccordionTab header="Reporte por RFC">
            {mostrarBotonExcel ?
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-3">
                  <h4>*RFC DE RECEPTOR:</h4>
                  <InputText id="rfc" name="twReceptor.rfc" value={twReceptor.rfc || ''} onChange={this.asignarValoresObjeto} className={errorRfc.rfc ? 'p-error' : ''} />
                  {errorRfc.rfc ? <div><br /> <Message severity="error" text={errorRfc.rfc} /> </div> : null}
                </div>


                <div className="p-col-12 p-md-3">
                  <br /><br /><br />

                  <Button label="Reporte por día" className="p-button-rounded p-button-warning" onClick={this.descargarDetalleExcelPorRfc} />

                </div>
                <div className="p-col-12 p-md-3">
                  <br /><br /><br />

                  <Button label="Reporte mensual" className="p-button-rounded p-button-warning" onClick={this.descargarDetalleExcelPorRfcMes} />

                </div>
                <div className="p-col-12 p-md-3">
                  <br /><br /><br />

                  <Button label="Reporte anual" className="p-button-rounded p-button-warning" onClick={this.descargarDetalleExcelPorRfcAnio} />

                </div>
              </div>
              : null}
          </AccordionTab>
          <AccordionTab header="Detallado de facturas y notas de crédito">
            {mostrarBotonExcel ?
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-3">
                  <br /><br /><br />

                  <Button label="Reporte por día" className="p-button-rounded p-button-warning" onClick={this.descargarDetalleIngresoEgreso} />

                </div>
                <div className="p-col-12 p-md-3">
                  <br /><br /><br />

                  <Button label="Reporte mensual" className="p-button-rounded p-button-warning" onClick={this.descargarDetalleIngresoEgresoMes} />

                </div>
                <div className="p-col-12 p-md-3">
                  <br /><br /><br />

                  <Button label="Reporte anual" className="p-button-rounded p-button-warning" onClick={this.descargarDetalleIngresoEgresoAnio} />

                </div>
              </div>
              : null}
          </AccordionTab>

          <AccordionTab header="Búsqueda por estado de la factura" headerStyle={mostrarOpcionEstado}>
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-4">
                <Button label="Activo" className="p-button-rounded p-button-warning" onClick={this.buscarFacturaActivo} />
              </div>
              <div className="p-col-12 p-md-4">
                <Button label="Cancelado" className="p-button-rounded p-button-warning" onClick={this.buscarFacturaCancelada} />
              </div>

            </div>
          </AccordionTab>

        </Accordion>

        <Card>
        <br />
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-4">
            {mostrarSeleccionados ? <Button label="Descargar cfdis" className="p-button-rounded p-button-warning"  onClick={this.descargarCfdis} /> : ''}

          </div>
          <div className="p-col-12">
              {paginacion.registrosTotales > 0 && (this.state.activeIndex === 0 || this.state.activeIndex === 1 || this.state.activeIndex === 2) ?
                <Button icon="pi pi-file" label="Descarga masiva XML y PDF" style={{ textAlign: 'rigth', marginLeft: '20px', backgroundColor: '#d76b48', borderColor: '#d76b48' }} onClick={this.descargaMasiva} />
                : null}
            </div>
        </div>
          <DataTable value={paginacion.datos} editable={true} scrollable={true} scrollHeight="280px"  >
          <Column body={this.actionTemplate} header="Selecciona" style={{ textAlign: 'center', width: '8em' }} />
            <Column field="twCfdi.uuid" header="Folio fiscal" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="twCfdi.total" header="Importe total" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column body={this.formatofechaCreacion} header="Fecha creación" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column body={this.formatofechaCertificacion} header="Fecha certificación" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column body={this.formatofechaCancelacion} header="Fecha cancelación" style={{ width: '200px' }} filter={false} />
            <Column field="twCfdi.formaPago" header="Forma Pago" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="twCfdi.metodoPago" header="Método Pago" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="twCfdi.totalImpuestosTrasladados" header="Metodo Pago" style={{ display: 'none' }} filter={false} autoLayout={true} />
            <Column field="twCfdi.totalImpuestosRetenidos" header="Metodo Pago" style={{ display: 'none' }} filter={false} autoLayout={true} />
            <Column body={this.formatoEstatus} header="Estado factura" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="twCfdi.llaveCfdi" header="Metodo Pago" style={{ display: 'none' }} filter={false} autoLayout={true} />
            <Column field="twCfdi.direccionCfdiSinFirma" header="Metodo Pago" style={{ display: 'none' }} filter={false} autoLayout={true} />
            <Column field="twCfdi.direccionCfdiFirmado" header="Metodo Pago" style={{ display: 'none' }} filter={false} autoLayout={true} />
            <Column field="twCfdi.direccionCfdiAcuseCancelacion" header="Metodo Pago" style={{ display: 'none' }} filter={false} autoLayout={true} />
            <Column field="twCfdi.direccionAcuseRecibo" header="Metodo Pago" style={{ display: 'none' }} filter={false} autoLayout={true} />
            <Column field="twCfdi.folio" header="Folio" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="twCfdi.serie" header="Serie" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column header="Descargar archivos" body={this.templateDescargaArchivos} style={{ textAlign: 'center', width: '12em' }} />
          </DataTable>
          <Paginator totalRecords={paginacion.registrosTotales} rows={paginacion.registrosPorPagina} first={first} onPageChange={this.onPage} rowsPerPageOptions={[20, 40, 60, 80, 100]}></Paginator>
        </Card>
      </div>

    );
  }

}
export default ConsultasCfdi;